import styled from 'styled-components';

import {
  Link,
} from 'react-router-dom';

import {
  Flex,
} from 'web-styled';

export const Search = styled(Flex).attrs({
  flex: '0 0 68px',
  align: 'center',
})`
  width: 100%;
  padding: 10px 15px;

  & > div {
    width: 100%;
  }

  & > button {
    position: absolute;
    right: 9px;
    bottom: -8px;
    z-index: 9;
  }
`;

export const Item = styled(Flex).attrs({
  flex: '0 0 60px',
  justify: 'space-between',
})`
  margin: 0;
  width: 100%;
  padding: 15px;

  .actions {
    opacity: 0;
  }

  &:first-of-type {
    margin-top: 10px;
  }

  &:hover {
    background: #fbfbfb;

    .actions {
      opacity: 1;
    }
  }

  &:hover div:last-of-type {
    visibility: visible;
  }

`;

export const Name = styled(Link)`
 font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${props => (props.inactive ? '#858585' : props.theme.colors.link)};
  line-height: 30px;

  & > i {
    margin: 0 5px;
    width: 23px;
    height: 13px;
  }
`;

export const Avatar = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
`;

export const Empty = styled(Flex).attrs({
  column: true,
  spacing: 10,
  align: 'center',
  justify: 'center',
})`
  width: 100%;
  height: 100%;
  color: #ccc;
  text-align: center;
  font-size: 12px;
`;

export const EmptyIcon = styled.img`
  width: 46px;
  height: 54px;
  filter: invert(78%) sepia(5%) saturate(27%) hue-rotate(251deg) brightness(98%) contrast(107%);
`;
